module.exports = __webpack_public_path__ + "img/card-4.98da5e82.png";